<template>
  <div style="height: 800px; position: relative">
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
    <Info :row="row" style="height: 510px; overflow: auto"></Info>
    <div class="table-header">
      {{ $t("bindFreight") + $t("information") }}
    </div>
    <Table :columns="tableTitle" :data="tableData" border stripe height="200">
    </Table>
    <div class="total-bill">
      <div class="label">{{ $t("total") }}:</div>
      <div class="label">
        <div class="titel" v-for="(item, index) in totalData" :key="index">
          <span>
            {{
              index == "total"
                ? $t("bindFreight") + ":"
                : index.toUpperCase() + ":"
            }}
          </span>
          <span class="text-red">{{ item }} </span>
          <span>{{ index == "total" ? this.$t("items") : "" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDoubleBill } from "@/api/double/list";
import Info from "_my/double-bill/info.vue";

export default {
  inject: ["$page"],
  components: {
    Info
  },
  props: {
    row: {
      type: Object
    }
  },
  data() {
    return {
      totalData: {},
      categoryList: [],
      currency: "",
      type: "IN",
      tableData: [],
      total: 0,
      loading: true,
      dataDetails: {},
      conmanyList: [],
      itemList: [],
      chargingList: []
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        key: "index",
        width: 65,
        align: "center",
        title: this.$t("serial_number")
      });
      columns.push({
        title: this.$t("operate"),
        key: "operator_name",
        align: "center",
        width: 100,
        tooltip: true
      });
      columns.push({
        title: this.$t("company"),
        key: "service_code",
        align: "center",
        width: 115
      });
      columns.push({
        title: this.$t("category"),
        key: "cate_name",
        minWidth: 100,
        align: "center"
      });
      columns.push({
        title: this.$t("expense_item"),
        minWidth: 100,
        align: "center",
        render(h, { row }) {
          return (
            <div>
              <span>
                {row.expenseItemInfo &&
                  row.expenseItemInfo.name +
                    "(" +
                    row.expenseItemInfo.code +
                    ")"}
              </span>
            </div>
          );
        }
      });
      columns.push({
        title: this.$t("expType"),
        key: "unit_name_txt",
        minWidth: 100,
        align: "center"
      });
      columns.push({
        title: this.$t("doublePrice"),
        align: "center",
        width: 110,
        key: "price"
      });
      columns.push({
        title: this.$t("currencyCode"),
        align: "center",
        key: "currency",
        width: 100
      });
      columns.push({
        title: this.$t("doubleAmount"),
        align: "center",
        key: "total_amount",
        width: 120
      });
      columns.push({
        title: this.$t("order_desc"),
        align: "center",
        tooltip: "true",
        key: "remarks",
        minWidth: 95
      });
      return columns;
    }
  },
  mounted() {
    this.SearchSubmit();
  },
  methods: {
    SearchSubmit() {
      this.loading = true;
      getDoubleBill(this.row.airway_number)
        .then(res => {
          this.loading = false;
          if (!res.data.status) {
            this.$Message["error"]({
              background: true,
              content: res.data.msg,
              duration: 5
            });
          } else {
            let data = res.data.payload;
            this.totalData = res.data.payload.TOTAL;
            this.tableData = data[this.type];
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.table-header {
  border: 1px solid #e8eaec;
  border-bottom: 0;
  padding: 14px 16px;
  line-height: 1;
}
.total-bill {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e8eaec;
  border-top: 0;
  font-weight: bold;
  padding: 0 10px;
  .label {
    display: flex;
    .titel {
      margin-left: 10px;
      .text-red {
        color: red;
        margin: 0 5px;
      }
    }
  }
}
</style>
